<div class="lc-cell-container" >
    <div style="display:flex; align-items:center;">
        <img src="assets/sp-green-compliant-icon.png" alt="Green Compliant img" class="compliant-icon">
        <div class="clickable" (click)="this.onUsageClick.emit(false)">{{compliance}}% Usage ({{complianceCount}})</div>
    </div>
    <progress-bar 
        [percentFilled]="compliance"
        [backgroundColor]="'#E0E0E0'"
        [barFillColor]="'#39B54A'"
        [height]="'8px'"
        [width]="'150px'"
    ></progress-bar>
    <div style="display:flex; align-items:center;">
        <img src="assets/sp-orange-noncompliant-icon.png" alt="Orange Noncompliant img" class="noncompliant-icon">
        <div class="clickable" (click)="this.onUsageClick.emit(true)">{{nonCompliance}}% Non-Usage ({{nonComplianceCount}})</div> 
    </div>
    <progress-bar 
        [percentFilled]="nonCompliance"
        [backgroundColor]="'#E0E0E0'"
        [barFillColor]="'#F17A22'"
        [height]="'8px'"
        [width]="'150px'"
    ></progress-bar>
</div>
